import build from './BUILD';

const APP_CONFIG = {
    build: check(build, 'BUILD (file, not env)'),

    app: {
        env: check(import.meta.env.VITE_ROCK_GUIDES_ENV, 'VITE_ROCK_GUIDES_ENV'),
        version: build,
        platform: 'web',
        platformId: 'https://guides.rockhome.app',
    },

    datadog: {
        clientToken: check(import.meta.env.VITE_DATADOG_CLIENT_TOKEN, 'VITE_DATADOG_CLIENT_TOKEN'),
    },

    firebase: {
        config: {
            apiKey: check(import.meta.env.VITE_FIREBASE_API_KEY, 'VITE_FIREBASE_API_KEY'),
            authDomain: check(import.meta.env.VITE_FIREBASE_AUTH_DOMAIN, 'VITE_FIREBASE_AUTH_DOMAIN'),
            projectId: check(import.meta.env.VITE_FIREBASE_PROJECT_ID, 'VITE_FIREBASE_PROJECT_ID'),
            storageBucket: check(import.meta.env.VITE_FIREBASE_STORAGE_BUCKET, 'VITE_FIREBASE_STORAGE_BUCKET'),
            messagingSenderId: check(
                import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
                'VITE_FIREBASE_MESSAGING_SENDER_ID',
            ),
            appId: check(import.meta.env.VITE_FIREBASE_APP_ID, 'VITE_FIREBASE_APP_ID'),
            measurementId: check(import.meta.env.VITE_FIREBASE_MEASUREMENT_ID, 'VITE_FIREBASE_MEASUREMENT_ID'),
        },
        appCheckSiteKey: check(import.meta.env.VITE_APP_CHECK_SITE_KEY, 'VITE_APP_CHECK_SITE_KEY'),
    },

    disableAnalytics: import.meta.env.VITE_DISABLE_ANALYTICS === 'true',

    commerce: {
        // Brandfetch Logo Link client id (free, from the Brandfetch developer portal) for rendering
        // retailer logos by domain. Optional — without it, logos fall back to a brand-color initial.
        brandfetchClientId: import.meta.env.VITE_BRANDFETCH_CLIENT_ID as string | undefined,
    },
};

// Helper to load value from env, and throw a helpful message when not found
function check(val: string | undefined, name: string, allowEmpty = false): string {
    if (!allowEmpty && (typeof val === 'undefined' || val === '')) {
        const msg = `Environment variable: ${name} is required!`;
        console.error(msg);
        return ENV_MISSING;

        // Can't throw right here, as it can cause the app to crash on startup, with no
        // opportunity to see what the error was.  Instead, we return ENV_MISSING and
        // check the environment for this value when we log the values on init.
        // throw Error(msg);
    }
    return val || '';
}

export const ENV_MISSING = '[MISSING]';
export default APP_CONFIG;
